export default __webpack_public_path__ + "static/media/grafema_tour-guide-cale-do-oiro_04.7fcabfca.jpg";